export default "__VITE_ASSET__l0whkPaD__"